module.exports = __webpack_public_path__ + "static/media/kv-ko.14849c64.jpg";